import styled from "styled-components";

const Wrapper = styled.div`
  label {
    margin-left: 1.2rem;
    cursor: pointer;
  }
`;

const Box = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  height: 25px;
  width: 25px;
  border: ${(props) =>
    props.checked
      ? "2px solid var(--secondary)"
      : props.disabled
      ? "1px solid #D9D9D9"
      : "1px solid var(--grey_10)"};
  border-radius: 50%;
  cursor: pointer;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: var(--secondary);
    display: ${(props) => (props.checked ? "block" : "none")};
  }

  input {
    visibility: hidden;
  }
`;

/**
 *
 * @param {Object} props
 * @param {string} props.id supply id
 * @param {string} [props.className] pass className when you need custom styling
 * @param {string} props.name
 * @param {string} [props.grey]
 * @param {string} [props.label]
 * @param {any} [props.value]
 * @param {boolean} [props.checked]
 * @param {boolean} [props.required]
 * @param {boolean} [props.disabled]
 * @param {Function} [props.onClick]
 *
 * @returns
 */

const RadioInput = ({
  id,
  className,
  name,
  grey,
  label,
  value,
  checked,
  required = false,
  disabled,
  onClick,
}) => {
  const radioInputSelector = `input[type="radio"][id=${id}][name=${name}]`;

  const handleClick = () => {
    if (disabled) return;

    document.querySelector(radioInputSelector).click();
    onClick?.();
  };

  return (
    <Wrapper className="flexRow alignCenter">
      <Box
        grey={grey}
        checked={checked}
        disabled={disabled}
        onClick={handleClick}
        className={className}
      >
        <input
          type="radio"
          name={name}
          id={`${id}`}
          value={value}
          required={required}
          disabled={disabled}
        />
      </Box>
      {label && (
        <label htmlFor={`${id}`} className="l3 ellipsify">
          {label}
        </label>
      )}
    </Wrapper>
  );
};

export default RadioInput;
